import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  DataTable,
  Page,
  Filters,
  Image,
  ChoiceList,
  Loading,
  Card,
  Text,
  Banner,
  Spinner,
  ButtonGroup,
  Button,
  Modal,
  Badge,
  Toast,
  TextContainer,
  Link,
  Icon,
  FormLayout,
  Tooltip,
  Select,
  Layout,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import Pagination from "@material-ui/lab/Pagination";
import { useNavigate, useLocation } from "react-router-dom";
import {
  accessEditBlogs,
  accessEditPages,
  accessViewPages,
} from "../../Helpers";
import {
  CircleInformationMajor,
  InfoMinor,
  PinUnfilledMajor,
  PinMajor,
} from "@shopify/polaris-icons";
import parse from "html-react-parser";
import {
  accessAddPages,
  accessAddBlogs,
  accessViewSections,
} from "../../Helpers";
import { ArrowUpMinor, ArrowDownMinor } from "@shopify/polaris-icons";

const Pages = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const refBoolPage = useRef(true);
  const refId = useRef(null);
  const [popupActive, setPopupActive] = useState(false);
  const perPage = 100;
  const [isLoading, setIsLoading] = useState(true);
  const [isListEmpty, setIsListEmpty] = useState(false);
  const [items, setItems] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [sortState, setSortState] = useState("-id");
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  const handleSort = () =>
    sortState === "id" ? setSortState("-id") : setSortState("id");
  const handleEdit = (id) => {
    if (props?.type === "careers") {
      navigate(`/admin/${props.type}/${id}`);
    } else {
      ((props.type === "pages" && accessEditPages()) ||
        (props.type === "blogs" && accessEditBlogs())) &&
        navigate(`/admin/${props.type}/${id}`);
    }
  };
  const handleSections = (id) => {
    navigate(`/admin/${props.type}/${id}/sections`);
  };
  const [ts, setTs] = useState("");
  const [isWebsiteProtected, setIsWebsiteProtected] = useState(false);
  const [channels, setChannels] = useState([]);
  const [selectedChannel, setSelectedChannel] = useState("");
  const handleSelectChangeChannel = (value) => {
    setSelectedChannel(value);
  };

  const handleUp = (e) => {
    const bodyObj = {
      direction: "up",
    };
    axios
      .post(`/blogs/${e.currentTarget.id}/sort`, bodyObj)
      .then((res) => {
        fetchData();
      })
      .catch((err) => console.log(""));
  };
  const handleDown = (e) => {
    const bodyObj = {
      direction: "down",
    };
    axios
      .post(`/blogs/${e.currentTarget.id}/sort`, bodyObj)
      .then((res) => {
        fetchData();
      })
      .catch((err) => console.log(""));
  };
  const [tags, setTags] = useState(["All"]);
  const [clickedTag, setClickedTag] = useState("All");

  const handlePinPage = (id, isPinned) => {
    const bodyObj = { is_pinned: isPinned ? 0 : 1 };
    axios
      .post(`pages/${id}/pin`, bodyObj)
      .then((result) => {
        setTs(+new Date());
      })
      .catch((err) => console.log(""));
  };
  useEffect(() => {
    setIsLoading(true);
    setIsListEmpty(false);
    setItems([]);
    fetchData();
  }, [
    page,
    sortState,
    availability,
    queryValue,
    ts,
    props,
    selectedChannel,
    clickedTag,
    location.pathname,
    props?.key,
  ]);
  useEffect(() => {
    axios
      .get(`settings/password-protection`)
      .then((result) => {
        result?.data?.data?.password_restriction && setIsWebsiteProtected(true);
      })
      .catch((err) => console.log(""));
  }, []);

  useEffect(() => {
    setTags(["All"]);
    axios
      .get(`${props.type}-tags`)
      .then((result) => {
        console.log("pages=", result.data.data);
        setTags((currentTags) => currentTags.concat(result.data.data));
        // setTags(result.data.data);
      })
      .catch((err) => console.log(""));
  }, [location.pathname]);
  async function fetchData() {
    let responsePages = "";
    let responseChannels = "";

    if (!channels.length) {
      try {
        responseChannels = await axios.get(`channels`);
        let array = [{ label: "All", value: "all" }];
        for (var i = 0; i < responseChannels.data.data.data.length; i++) {
          let item = responseChannels.data.data.data[i];
          array.push({ label: item.name, value: String(item.id) });
        }
        setChannels(array);
      } catch (error) {
        console.log(error);
      }
    }
    try {
      responsePages = await axios.get(
        `/${props.type}?per_page=${perPage}&page=${
          refBoolPage.current ? page : 1
        }${
          queryValue
            ? `&filter[${
                availability === "" ? "title" : availability
              }]=${queryValue}`
            : ""
        }${
          selectedChannel !== "" && selectedChannel !== "all"
            ? `&filter[channels.id]=${selectedChannel}`
            : ""
        }${
          clickedTag !== "" && clickedTag !== "All"
            ? `&filter[tags]=${clickedTag}`
            : ""
        }`
      );
      !responsePages.data.data.data.length
        ? setIsListEmpty(true)
        : setIsListEmpty(false);
      setTotalPages(responsePages.data.data.total);
      setItems(
        responsePages.data.data.data.map((item, index) => [
          <div
            style={{ cursor: "pointer" }}
            onClick={() => handlePinPage(item.id, item.is_pinned)}
          >
            <Icon source={item.is_pinned ? PinMajor : PinUnfilledMajor} />
          </div>,

          <div className="row_click2">
            {item?.title ? (
              <div className="rowDiv">
                <Link monochrome onClick={() => handleEdit(item.id)}>
                  {item.title["en"]}
                </Link>
                {item?.instructions ? (
                  <div style={{ cursor: "pointer", marginLeft: "1rem" }}>
                    <Tooltip content={parse(item?.instructions)}>
                      <Icon source={CircleInformationMajor} color="subdued" />
                    </Tooltip>
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : (
              ""
            )}
          </div>,
          // <div className="row_click2">{item?.alias ? item?.alias : ""}</div>,
          <div className="row_click2">
            <Badge status={item.is_active ? "success" : "info"}>
              {item.is_active ? "Active" : "Draft"}
            </Badge>
          </div>,
          // <div className="row_click2">
          //   {item?.instructions ? (
          //     <div style={{ cursor: "pointer" }}>
          //       <Tooltip content={parse(item?.instructions)}>
          //         <Icon source={CircleInformationMajor} color="subdued" />
          //       </Tooltip>
          //     </div>
          //   ) : (
          //     ""
          //   )}
          // </div>,
          <div className="me-3">
            <ButtonGroup>
              {props.type === "blogs" && (
                <Button id={String(item.id)} onClick={(e) => handleUp(e)}>
                  <Icon source={ArrowUpMinor}></Icon>
                </Button>
              )}
              {props.type === "blogs" && (
                <Button id={String(item.id)} onClick={(e) => handleDown(e)}>
                  <Icon source={ArrowDownMinor}></Icon>
                </Button>
              )}

              <Button
                primary
                onClick={() => handleSections(item.id)}
                disabled={!accessViewSections()}
              >
                Sections
              </Button>
            </ButtonGroup>
          </div>,
        ])
      );
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  }

  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    // {
    //   key: "availability",
    //   label: "Filter by",
    //   filter: (
    //     <ChoiceList
    //       title="Filter by"
    //       titleHidden
    //       choices={[{ label: "Title", value: "title" }]}
    //       selected={availability || []}
    //       onChange={handleAvailabilityChange}
    //     />
    //   ),
    //   shortcut: true,
    // },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }

  const loadingMarkup = isLoading ? <Loading /> : null;
  const emtyState = isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <Image src={emptyListImage}></Image>
      </div>
      <div className="mb-3">
        <Text variant="headingLg" as="h5" color="subdued">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This page has been successfully deleted"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const [activeDelete, setActiveDelete] = useState(false);

  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDelete = (id) => {
    refId.current = id;
    setActiveDelete(true);
  };

  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`brands/${refId.current}`)
      .then((result) => {
        toggleActive();
        setIsSaving(false);
        setActiveDelete(!activeDelete);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };

  return (
    accessViewPages() && (
      <Page
        title={props.title}
        primaryAction={
          <Button
            primary
            onClick={() => navigate(`/admin/${props.type}/new`)}
            disabled={
              (props.type === "pages" && !accessAddPages()) ||
              (props.type === "blogs" && !accessAddBlogs())
            }
          >
            {props.button}
          </Button>
        }
      >
        <FormLayout>
          {isWebsiteProtected && (
            <Banner
              title="Website access is restricted"
              // action={{ content: "Edit address" }}
              status="warning"
            >
              While your website is in development, only visitors with the
              password can access it.
            </Banner>
          )}

          <Card>
            {loadingMarkup}

            <Card.Section>
              <div className="boxTags">
                {tags?.length
                  ? tags.map((element, index) => {
                      return (
                        <div
                          key={index}
                          className={`buttonTags ${
                            clickedTag === element ? "clickedTag" : ""
                          }`}
                          onClick={() => {
                            setClickedTag(element);
                          }}
                        >
                          {element}
                        </div>
                      );
                    })
                  : null}
              </div>

              <FormLayout>
                <Layout>
                  <Layout.Section>
                    <Filters
                      queryValue={queryValue}
                      filters={filters}
                      appliedFilters={appliedFilters}
                      onQueryChange={handleFiltersQueryChange}
                      onQueryClear={handleQueryValueRemove}
                      onClearAll={handleFiltersClearAll}
                    />
                  </Layout.Section>
                  <Layout.Section secondary>
                    <Select
                      label="Filter by Channel"
                      labelInline
                      options={channels}
                      onChange={handleSelectChangeChannel}
                      value={selectedChannel}
                    />
                  </Layout.Section>
                </Layout>
              </FormLayout>
            </Card.Section>

            <DataTable
              columnContentTypes={["text", "text", "text", "text"]}
              headings={[
                <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
                <Text variant="bodyMd" as="p" fontWeight="medium">
                  Title
                </Text>,
                // <Text variant="bodyMd" as="p" fontWeight="medium">
                //   Alias
                // </Text>,
                <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
                // <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
                <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
              ]}
              rows={items}
              sortable={[false, false, false, false]}
              defaultSortDirection="descending"
              initialSortColumnIndex={0}
              onSort={handleSort}
              verticalAlign="middle"
              stickyHeader
              // hasZebraStripingOnData
              footerContent={
                items?.length &&
                `Showing ${items.length} of ${totalPages} results`
              }
              increasedTableDensity
            />

            {emtyState}
          </Card>
          {Math.ceil(totalPages / perPage) >= 2 && (
            <div
              style={{
                paddingTop: "10px",
                textAlign: "center",
                paddingBottom: "10px",
              }}
            >
              <Pagination
                count={Math.ceil(totalPages / perPage)}
                page={page}
                onChange={handleChangePage}
                size="large"
              />
            </div>
          )}
        </FormLayout>
        <Modal open={popupActive} loading={true}></Modal>
        <Modal
          open={activeDelete}
          onClose={handleChangeModalDelete}
          title="Delete Brand"
          primaryAction={{
            content: "Yes",
            onAction: handleYesDelete,
            loading: isSaving,
          }}
          secondaryActions={[
            {
              content: "No",
              loading: isSaving,
              onAction: handleChangeModalDelete,
            },
          ]}
        >
          <Modal.Section>
            <TextContainer>
              <p>Are you sure you want to delete this brand?</p>
            </TextContainer>
          </Modal.Section>
        </Modal>

        {toastMarkup}
      </Page>
    )
  );

  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      default:
        return value;
    }
  }

  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
  function findElementByID(array, id) {
    return array.find((element) => {
      return element.id === id;
    });
  }
};

export default Pages;
